var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphicDesignLayoutImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:35;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000178895203665248648920000016643517685704152452_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L281.2,584l128.7,168.3c15.7,20.5,24.2,45.7,24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L798.8,584L670.1,752.3c-15.7,20.5-24.2,45.7-24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 540,
    y1: 24,
    x2: 540,
    y2: 593.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 581.6,
    r: 42.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 365.9,
    y1: 899.2,
    x2: 711.8,
    y2: 899.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.3,
    y: 899.2,
    width: 150.6,
    height: 117.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000030472249092312949170000005231901847544293036_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22.5,
    className: "st4",
    width: 1037.5,
    height: 1037.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesignLayoutImagePlaceholder);
export default __webpack_public_path__ + "static/media/Graphic-Design-Layout-Image-Placeholder.0ad11f71b45bfb69a6fed585e070765f.svg";
export { ForwardRef as ReactComponent };